<template>
  <div>
    <b-sidebar
      id="structure-people-link-sidebar-right"
      class="structure-sidebar-link-modal"
      right
      bg-variant="white"
      width="407px"
      v-model="isOpen"
      @hidden="closeModal"
    >
      <template>
        <div>
          <div class="text-block">
            <div class="title">{{ $t('DepartmentPage.LinkPerson') }}</div>
            <div class="subtitle">
              {{ $t('StructurePage.PeopleSubTitleLinkModal') }}
            </div>
          </div>
          <div class="search-block">
            <div class="label-title">{{ $t('Menu.Items.People') }}</div>
            <div class="div-custom-input">
              <div class="icon-block">
                <SearchIcon class="search-icon" />
              </div>
              <b-form-input
                class="search-input-link-people"
                type="text"
                v-model="searchFilter"
                :placeholder="$t('DepartmentPage.Search')"
                @input="(e) => updateFilter(e)"
              />
            </div>
          </div>
          <div class="action-block">
            <div class="select-all">
              <div
                :class="['checkbox-container', allPeopleChecked ? 'checked' : '']"
                @click="checkAllPeople()"
              >
                <span class="icon-checkbox"><CheckIcon /></span>
              </div>
              <span class="text">
                {{ $t('SelectAll') }}
              </span>
            </div>
            <div class="function-filter">
              <span>{{ $t('DepartmentPage.Function') }}</span>
              <div
                id="filter-select-link"
                class="filter"
                tabindex="0"
              >
                <span>{{ $t(selectedFilter) }}</span>
                <ArrowDown class="arrow-down" />
              </div>
            </div>
            <Popover
              :items="functionList"
              target="filter-select-link"
              placement="bottom"
              custom-position="action-button function-filter"
              triggers="focus"
            />
          </div>
          <div
            class="people-block"
            v-if="forceRenderLinkPeople"
          >
            <div
              v-if="filteredList.length === 0"
              class="block-no-results"
            >
              <div class="no-results">
                <SearchIcon />
                <p class="text">{{ $t('NoResultsFound') }}</p>
              </div>
            </div>
            <div v-else>
              <div
                v-for="person in filteredList"
                :key="person.guid"
              >
                <div class="user-info-block">
                  <div class="check-person">
                    <div
                      :class="[
                        'checkbox-container __no-action-default',
                        person.checked ? 'checked' : ''
                      ]"
                      @click="toggleCheckbox(person)"
                    >
                      <span class="icon-checkbox __no-action-default"><CheckIcon /></span>
                    </div>
                  </div>
                  <div class="picture">
                    <img
                      v-if="person.photo"
                      :src="person.photo"
                      alt="User photo"
                    />
                    <AvatarPlaceholder
                      v-else
                      :size="device !== 'mobile' ? '40px' : '30px'"
                      :text="picturePlaceholder(person.first_name, person.last_name)"
                    />
                  </div>
                  <div class="text-block">
                    <div class="people-name">{{ person.first_name }} {{ person.last_name }}</div>
                    <div class="people-code">{{ person.code }}</div>
                  </div>
                  <div
                    v-if="person.functions.length"
                    class="roles-block"
                  >
                    <div class="role-tag">
                      {{ $t(person.functions[0].name) }}
                    </div>
                    <div
                      v-if="person.functions.length > 1"
                      class="role-tag"
                    >
                      + {{ person.functions.length - 1 }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <b-col
          md="12"
          class="footer-sidebar"
        >
          <div class="d-flex">
            <b-button
              class="btn-cancel btn-footer"
              @click="closeModal()"
            >
              {{ $t('RefuseStatus.Cancel') }}
            </b-button>
            <b-button
              class="btn-save btn-footer"
              @click="onLinkPeople()"
            >
              {{ $t('IntegrationPage.Link') }}
            </b-button>
          </div>
        </b-col>
      </template>
    </b-sidebar>
  </div>
</template>

<script>
  import { avatarText } from '@core/utils/filter';
  import { BSidebar, BCol, BButton, BFormInput } from 'bootstrap-vue';
  import { mapState, mapMutations } from 'vuex';
  import Popover from '@core/layouts/layout-horizontal/components/Menu/Popover.vue';
  import AvatarPlaceholder from '@/@core/components/avatar-placeholder/index.vue';
  import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue';

  export default {
    components: {
      BSidebar,
      BCol,
      BButton,
      BFormInput,
      AvatarPlaceholder,
      ToastificationContent,
      Popover,
      ArrowDown: () => import('@core/assets/icons/arrow-down-orange.svg'),
      CheckIcon: () => import('@core/assets/icons/check-icon.svg'),
      SearchIcon: () => import('@core/assets/icons/search-icon.svg')
    },
    props: {
      device: {
        type: String,
        default: 'desktop'
      },
      currentId: {
        type: Number,
        default: null
      },
      prefix: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        forceRenderLinkPeople: true,
        allPeopleChecked: false,
        isOpen: false,
        searchFilter: '',
        selectedFilter: 'DepartmentPage.All',
        filteredList: [],
        functionList: [
          {
            title: 'DepartmentPage.All',
            click: () => {
              this.selectedFilter = 'DepartmentPage.All';
            }
          }
        ]
      };
    },
    mounted() {
      this.UPDATE_MODAL_LINK_PEOPLE_TOGGLE(false);
      this.filteredList = this.peopleToLink;
    },
    methods: {
      ...mapMutations('app', ['UPDATE_FLAG_SHOW_OVERLAY']),
      ...mapMutations('structures', [
        'UPDATE_MODAL_LINK_PEOPLE_TOGGLE',
        'UPDATE_PEOPLE_TO_LINK_LIST',
        'UPDATE_PEOPLE_LIST'
      ]),
      closeModal() {
        this.UPDATE_MODAL_LINK_PEOPLE_TOGGLE(false);
      },
      picturePlaceholder(first_name, last_name) {
        return avatarText(first_name, last_name);
      },
      updateFilterByFunction(func) {
        if (func === 'DepartmentPage.All') {
          this.filteredList = this.peopleToLink;
        } else {
          this.filteredList = this.peopleToLink.filter((person) =>
            person.functions.some((funcObj) => funcObj.name === func)
          );
        }
      },
      getAllFunctionsFilter() {
        this.functionList = [
          {
            title: 'DepartmentPage.All',
            click: () => {
              this.selectedFilter = 'DepartmentPage.All';
            }
          },
          ...(this.rolesList?.reduce((acc, e) => {
            const existingFunction = acc.find((f) => f.title === e.name);
            if (!existingFunction) {
              acc.push({
                title: e.name,
                click: () => {
                  this.selectedFilter = e.name;
                }
              });
            }
            return acc;
          }, []) || [])
        ];
      },
      toggleCheckbox(elem) {
        if (!elem.checked) {
          elem['checked'] = true;
        } else {
          elem['checked'] = false;
          this.allPeopleChecked = false;
        }
        this.forceRenderLinkPeopleList();
      },
      showToast(title, icon, text, variant) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: title,
            icon: icon,
            text: text,
            variant
          }
        });
      },
      unCheckAllPeople() {
        this.peopleToLink.map((e) => {
          e['checked'] = false;
        });
        this.allPeopleChecked = false;
      },
      updateFilter(e) {
        this.updateFilterByFunction(this.selectedFilter);
        const arr = this.filteredList;
        const filterValue = e.toLowerCase();
        const regex = new RegExp(filterValue, 'i');

        const filteredArray = arr.filter((item) => {
          const fullName = `${item.first_name} ${item.last_name}`.toLowerCase();

          return regex.test(fullName) || regex.test(item.code);
        });
        this.filteredList = filteredArray;
      },
      checkAllPeople() {
        this.filteredList.map((e) => {
          if (this.allPeopleChecked) {
            e['checked'] = false;
          } else {
            e['checked'] = true;
          }
        });
        this.verifyAllChecked();
        this.forceRenderLinkPeopleList();
      },
      verifyAllChecked() {
        this.filteredList.map((e) => {
          if (!e.checked) {
            this.allPeopleChecked = false;
          } else {
            this.allPeopleChecked = true;
          }
        });
      },
      forceRenderLinkPeopleList() {
        this.forceRenderLinkPeople = false;
        this.$nextTick().then(() => {
          this.forceRenderLinkPeople = true;
        });
      },
      async getPeopleToLink() {
        this.UPDATE_FLAG_SHOW_OVERLAY(true);
        await this.$http
          .get(`/api/${this.prefix}/myconfig/workcenter/${this.currentId}/user/context`)
          .then((response) => {
            this.UPDATE_PEOPLE_TO_LINK_LIST(response.data.data);
            this.updateFilterByFunction(this.selectedFilter);
            this.forceRenderLinkPeopleList();
            this.UPDATE_FLAG_SHOW_OVERLAY(false);
          })
          .catch((error) => console.error(error));
      },
      async onLinkPeople() {
        const hasChecked = this.filteredList.find((e) => e.checked);
        if (!hasChecked) return;

        this.UPDATE_FLAG_SHOW_OVERLAY(true);

        const checkedPeople = this.peopleToLink.filter((e) => !!e.checked);

        const payload = {
          users: checkedPeople.map((e) => e.guid)
        };

        await this.$http
          .post(`/api/${this.prefix}/myconfig/workcenter/${this.currentId}/user/add`, payload)
          .then((response) => {
            this.unCheckAllPeople();
            checkedPeople.map((e) => this.peopleList.push(e));
            this.UPDATE_PEOPLE_LIST(this.peopleList);
            this.getPeopleToLink();
            this.showToast(
              this.$t('IntegrationPage.success'),
              'SmileIcon',
              this.$t('DepartmentPage.RelatedPersons'),
              'success'
            );
            this.$emit('updateDragList');
          })
          .catch((error) => {
            error.map((err) => {
              this.showToast(this.$t('Error'), 'FrownIcon', err.message, 'danger');
            });
          })
          .finally(() => this.UPDATE_FLAG_SHOW_OVERLAY(false));
      }
    },
    computed: {
      ...mapState('structures', {
        isModalLinkPeopleOpen: 'isModalLinkPeopleOpen',
        peopleToLink: 'peopleToLink',
        peopleList: 'peopleList',
        rolesList: 'rolesList'
      })
    },
    watch: {
      isModalLinkPeopleOpen(v) {
        this.isOpen = v;
        this.getAllFunctionsFilter();
        if (v) {
          this.getPeopleToLink();
        } else {
          this.selectedFilter = 'DepartmentPage.All';
        }
      },
      selectedFilter(v) {
        this.searchFilter = '';
        this.unCheckAllPeople();
        this.updateFilterByFunction(v);
      }
    }
  };
</script>
<style lang="scss">
  .structure-sidebar-link-modal {
    .b-sidebar.b-sidebar-right {
      transition: all 0.5s ease-out;
      border-left: 1px solid #cfc4be;
      @media (max-width: 814px) {
        width: 50vw !important;
      }
    }

    .separator {
      width: 100%;
      height: 1px;
      background: #cfc4be;
    }

    .b-sidebar {
      height: 100% !important;

      .b-sidebar-header {
        display: none;
      }

      .b-sidebar-body {
        padding: 16px;
        overflow: hidden;

        .text-block {
          .title {
            color: #4c4541;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
            padding-bottom: 8px;
          }

          .subtitle {
            color: #998f8a;
            font-size: 14px;
            font-weight: 400;
            line-height: 20px;
            padding-bottom: 16px;
          }
        }

        .search-block {
          .div-custom-input {
            display: flex;
            align-items: center;
            border-radius: 4px;
            width: 100%;
            overflow: hidden;
            border: 1px solid #cfc4be;
            .icon-block {
              display: flex;
              align-items: center;
              padding-left: 14px;
              height: 14px;
              .search-icon {
                width: 14px;
                height: 14px;
                fill: #cfc4be;
              }
            }
            .search-input-link-people {
              width: 100% !important;
              border: none;
              overflow: hidden;

              &:focus {
                box-shadow: none;
              }
              &.b-form-input {
                padding: 0 !important;
                display: flex;
                align-items: center !important;
              }
            }
          }
          .label-title {
            color: #4c4541;
            font-size: 16px;
            font-weight: 600;
            line-height: 26px;
            padding-bottom: 8px;
          }
        }

        .action-block {
          display: flex;
          justify-content: space-between;
          padding: 8px 0;

          .select-all {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 0 16px;

            .text {
              color: #4c4541;
              font-size: 14px;
              font-weight: 600;
              line-height: 20px;
            }
          }

          .function-filter .filter {
            color: #974900;
            font-size: 12px;
            font-weight: 600;
            line-height: 20px;
            letter-spacing: 0.15px;
          }

          .function-filter {
            display: flex;
            align-items: center;
            gap: 8px;
            color: #4c4541;
            font-size: 14px;
            font-weight: 600;
            line-height: 20px;

            .filter {
              display: flex;
              align-items: center;
              gap: 8px;
              padding: 4px 10px;
              border-radius: 5px;
              cursor: pointer;

              .arrow-down {
                width: 12px;
                height: 12px;
              }

              &:hover {
                background: #ffede2;
              }

              &:active {
                background: #ffdbc4;
              }
            }
          }
        }

        .people-block {
          padding-bottom: 16px;
          overflow: auto;
          height: calc(100vh - 281px);

          &:has(.block-no-results) {
            overflow-y: hidden;
          }

          .block-no-results {
            height: 100%;
            padding: 16px 0;
            .no-results {
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              gap: 16px;
              border-radius: 6px;
              border: 1px solid #cfc4be;

              svg {
                width: 16px;
                height: 16px;
                fill: #998f8a;
              }

              .text {
                margin: 0;
                color: #998f8a;
                font-size: 16px;
                font-weight: 600;
                line-height: 26px;
              }

              @media (max-width: 480px) {
                svg {
                  width: 12px;
                  height: 12px;
                }
                .text {
                  font-size: 12px;
                  line-height: 16px;
                }
              }
            }
          }

          .user-info-block {
            display: flex;
            align-items: center;
            gap: 8px;
            padding: 7.5px 16px;
            overflow: hidden;
            border-bottom: 1px solid #eee;
            background: #fff;

            .picture img {
              width: 40px;
              border-radius: 50%;

              @media (max-width: 480px) {
                width: 30px;
              }
            }

            .check-person {
              display: flex;

              .checkbox-container {
                margin: 0;
              }
            }

            .text-block {
              overflow: hidden;
              .people-name {
                color: #4c4541;
                font-size: 14px;
                font-weight: 600;
                line-height: 20px;
                white-space: nowrap;
                word-break: break-all;
                overflow: hidden;
                text-overflow: ellipsis;
              }
              .people-code {
                color: #998f8a;
                font-size: 12px;
                font-weight: 400;
                line-height: 16px;
              }
            }
          }

          .roles-block {
            display: flex;
            justify-content: flex-end;
            gap: 8px;
            padding-right: 16px;
            margin-left: auto;
            .role-tag {
              white-space: nowrap;
              border-radius: 4px;
              background: #eceff1;
              padding-inline: 9px;
              color: #607d8b;
              text-align: center;
              font-size: 12px;
              font-weight: 600;
              line-height: 16px;
            }
          }

          &::-webkit-scrollbar {
            width: 7px;
          }

          &::-webkit-scrollbar-track {
            background: #fff;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #cfc4be;
            border-radius: 9px;
          }
        }

        .checkbox-container {
          display: flex;
          background-color: #fff;
          border: 1px solid #cfc4be;
          border-radius: 3px;
          cursor: pointer;
          width: 18px;
          height: 18px;

          .icon-checkbox {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 2px;
            svg {
              width: 12px;
              height: 12px;
            }
          }
          &.checked {
            background-color: #974900;
            display: block;
          }
        }

        &::-webkit-scrollbar {
          width: 7px;
        }

        &::-webkit-scrollbar-track {
          background: #fff;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #cfc4be;
          border-radius: 9px;
        }
      }
    }

    .footer-sidebar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding: 16px;
      border-top: 1px solid #cfc4be;
      background: #fff;

      .btn-footer {
        box-shadow: none;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        border-radius: 5px;

        &:hover {
          box-shadow: none;
        }

        &.btn-reset {
          background-color: transparent !important;
          color: #974900 !important;
          font-size: 12px !important;
          border: 1px solid transparent !important;
          padding: 4px 14px;

          &:hover {
            background-color: #ffede2 !important;
          }

          &:active {
            background-color: #ffdbc4 !important;
          }
        }

        &.btn-cancel {
          background-color: transparent !important;
          color: #974900 !important;
          border: 1px solid #974900 !important;
          margin-right: 8px;
          padding: 8px 21px;

          &:hover {
            background-color: #ffede2 !important;
          }

          &:active {
            background-color: #ffdbc4 !important;
          }
        }

        &.btn-save {
          border: 1px solid #974900 !important;
          background-color: #974900 !important;
          color: #ffff !important;
          padding: 8px 21px;

          &:hover {
            background-color: #9f5714 !important;
          }

          &:active {
            background-color: #a45f1f !important;
          }
        }
      }
    }
  }
</style>
